<template>
    <main class="dashboard">
        <div class="main-section" style="min-height: 100vh; background: rgb(248, 249, 253);">
            <div class="container">
                <div class="columns has-text-centered ml-0 mt-0">
                    <div class="column is-6 plainCard has-background-white">
                        <p class="title is-5">Datos Básicos</p>
                        <div class="columns">
                            <div class="column is-4"> <strong>Fecha de inscripción:</strong></div>
                            <div class="column is-8" v-if="!isLoading">{{
                                moment(basicData.oldest_join_date).format('DD-MM-YYYY') }}</div>
                        </div>
                        <div class="columns">
                            <div class="column is-4"> <strong>Usuarios:</strong></div>
                            <div class="column is-8">
                                <table>
                                    <tr v-for="user in allUsers" v-bind:key="user.user_id">
                                        <td>
                                            <SimpleButton @click="() => addUser(user.user_id, user.user_email)"
                                                class="user_button">
                                                {{ user.user_email }}
                                            </SimpleButton>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <SimpleButton @click="() => addUser(-1, '')"
                                                class="user_button add_user_button">
                                                Agregar Usuario +
                                            </SimpleButton>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-4"><strong>Estado:</strong></div>
                            <div class="column is-8"></div>
                        </div>
                        <div class="columns">
                            <div class="column is-4"><strong>Libro General:</strong></div>
                            <div class="column is-8 buttons are-small">
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    @click="() => openUpdateModalIdSheet()">
                                    Actualizar
                                </SimpleButton>
                                <SimpleButton class="is-secondary"
                                    :buttonStyle="`linear-gradient(225deg, #d0d0ff, #f0f0ff)`"
                                    v-if="basicData.general_book_id_sheet" @click="() => goToSheet()">
                                    Ir
                                </SimpleButton>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-4">
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    @click="() => openUpdateOperationsByUserModal()">
                                    <span>Operaciones por usuario</span>
                                </SimpleButton>
                            </div>
                            <div class="column is-4">
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    @click="() => openUpdateUsernamePassModal()">
                                    <span>Actualizar contraseña</span>
                                </SimpleButton>
                            </div>
                        </div>
                    </div>
                    <div class="column is-one-quarter plainCard has-background-white">
                        <p class="title is-5">Contacto</p>
                        <div class="columns columns_logo">
                            <table>
                                <tr>
                                    <td class="logo_column">
                                        <div class="is-full">
                                            <img :src="basicData.logo" class="company_logo" v-if="basicData.logo" />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="logo_column">
                                        <div class="is-full">
                                            <input type="file" ref="fileInput" accept="image/*" style="display: none;"
                                                @change="handleFileUpload" />
                                            <SimpleButton class="user_button add_user_button"
                                                :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                                @click="() => triggerFileDialog()">
                                                <span>Subir logo</span>
                                            </SimpleButton>
                                            <SimpleButton v-if="basicData.logo" class="btn_danger"
                                                @click="deleteImage()">
                                                <span>X</span>
                                            </SimpleButton>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <a href="">Sugerencia minuta</a>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <a href="">Enviar correo contacto</a>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <a href="">Enviar correo contador</a>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <a href="">Agregar contacto</a>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    @click="() => openEnviarCorreoTaxDocuments('sii')">
                                    <table>
                                        <tr>
                                            <td class="sii_b_msg"><span>Enviar correo documentos SII</span></td>
                                            <td class="sii_logo_td"><img :src="sii_logo" class="sii_logo" /></td>
                                        </tr>
                                    </table>
                                </SimpleButton>
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    @click="() => openEnviarCorreoTaxDocuments('banks')">
                                    <table>
                                        <tr>
                                            <td class="sii_b_msg"><span>Enviar correo documentos Bancos</span></td>
                                            <td class="sii_logo_td"><img :src="bank_logo" class="sii_logo" /></td>
                                        </tr>
                                    </table>
                                </SimpleButton>
                            </div>
                        </div>
                    </div>
                    <div class="column is-one-quarter plainCard has-background-white">
                        <p class="title is-5">Reporte</p>
                        <div class="columns">
                            <div class="column is-full">
                                <a href="">Ver reporte</a>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <a href="">Configurar reporte</a>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <a href="">Configurar paneles</a>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    @click="() => openModalReloadReport('sii')">
                                    <table>
                                        <tr>
                                            <td class="sii_b_msg"><span>Recargar SII desde fintoc</span></td>
                                            <td class="sii_logo_td"><img :src="sii_logo" class="sii_logo" /></td>
                                        </tr>
                                    </table>
                                </SimpleButton>
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    @click="() => openModalReloadReport('bank')">
                                    <table>
                                        <tr>
                                            <td class="sii_b_msg"><span>Recargar movimientos desde fintoc</span></td>
                                            <td class="sii_logo_td"><img :src="bank_logo" class="sii_logo" /></td>
                                        </tr>
                                    </table>
                                </SimpleButton>
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    :disabled="loadingReloadDrive" @click="() => sendObligationsToDrive('sii')">
                                    <table>
                                        <tr>
                                            <td class="sii_b_msg"><span>Recargar drive para obligaciones</span></td>
                                            <td class="sii_logo_td"><img :src="sii_logo" class="sii_logo" /></td>
                                        </tr>
                                    </table>
                                </SimpleButton>
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    :disabled="loadingReloadDrive" @click="() => sendObligationsToDrive('bank')">
                                    <table>
                                        <tr>
                                            <td class="sii_b_msg"><span>Recargar drive para movimientos</span></td>
                                            <td class="sii_logo_td"><img :src="bank_logo" class="sii_logo" /></td>
                                        </tr>
                                    </table>
                                </SimpleButton>
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`"
                                    :disabled="loadingReloadDrive"
                                    @click="() => sendObligationsToDrive('classification')">
                                    <table>
                                        <tr>
                                            <td class="sii_b_msg"><span>Recargar drive para clasificaciones</span></td>
                                            <td class="sii_logo_td"><img :src="sii_logo" class="sii_logo" /></td>
                                        </tr>
                                    </table>
                                </SimpleButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { deleteUploadedFile, getUsersByCompany, uploadFile } from "@/api/carteraAnalista";
import { downloadMovementsToSheet, downloadObligationsToSheet, exportClassificationsToSheet } from "@/api/downloadObligationsToSheet";
import { getFilesUsersByCompany } from "@/api/uploadFiles";
import AssignUsers from "@/components/modals/AssignUsers";
import ChangeOperationsByUsers from "@/components/modals/ChangeOperationsByUsers";
import ChangeUsernamePass from "@/components/modals/ChangeUsernamePass";
import IdSheetUpdate from "@/components/modals/IdSheetUpdate";
import ReloadFintocByCompany from "@/components/modals/ReloadFintocByCompany";
import SimpleButton from "@/components/modals/SimpleButton";
import UploadFileAsUserModal from "@/components/modals/UploadFileAsUserModal";
import { consoleHandlerError, notificate } from "@/utils/message";
import moment from "moment";
import { mapState } from "vuex";

export default {
    name: "CompanyInfoBasicData",
    components: {
        SimpleButton,
    },
    props: {
        basicData: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },
    created() {
        const companyId = this.$route.query.companyId;
        this.companyRut = this.$route.query.companyRut;
        if (!companyId) {
            this.$router.push({ name: 'panel-analista' });
        }
        getFilesUsersByCompany(companyId).then(({ data }) => {
            this.allFilesByUser = data
        });
        this.load_company_users();
    },
    data() {
        return {
            publicPath: "http://" + window.location.hostname,
            modalDefault: {
                parent: this,
                hasModalCard: true,
                width: '99%',
                height: 1000,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
                "full-screen": true,
            },
            modalDefaultUpdateSheet: {
                parent: this,
                hasModalCard: true,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
            },
            fileData: [],
            allFilesByUser: [],
            allUsers: [],
            companyRut: '',
            loadingReloadDrive: false,
            isLoading: true,
        };
    },
    computed: {
        ...mapState("userAuth", ["user"]),
        sii_logo: function () { return `${this.publicPath}/Logo_de_Servicio_de_Impuestos_Internos.png` },
        bank_logo: function () { return `${this.publicPath}/bank_logo.png` },
        arrow() { return `${this.publicPath}/arrow-back-128.png`; }
    },
    methods: {
        back() {
            window.location.href = "#/panel-analista";
        },
        triggerFileDialog() {
            this.$refs.fileInput.click();
        },
        async deleteImage() {
            if (!this.basicData.logo) return;

            try {
                const response = await deleteUploadedFile(this.basicData.companyId);

                if (response.data['success']) {
                    this.basicData.logo = null
                }
                this.$emit("file-uploaded", response.data);
            } catch (error) {
                console.error("Error uploading file: ", error);
            }
        },
        async handleFileUpload(event) {
            console.log('helo');
            const file = event.target.files[0];
            if (!file) return;

            try {
                const response = await uploadFile(this.basicData.companyId, file);

                if (response.data['success']) {
                    this.basicData.logo = response.data['image']
                }
                this.$emit("file-uploaded", response.data);
            } catch (error) {
                console.error("Error uploading file:", error);
            }
        },
        load_company_users() {
            const companyId = this.$route.query.companyId;
            getUsersByCompany(companyId).then(({ data }) => {
                this.allUsers = data;
            })
        },
        addUser(user_id, user_email) {
            console.log('user_id', user_id);
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: AssignUsers,
                canCancel: ['escape', 'button', 'outside'],
                props: {
                    user_id: user_id,
                    user_email: user_email,
                    company_id: this.basicData.companyId,
                },
                events: {
                    close: () => {
                        this.load_company_users();
                    }
                },
            });

        },
        moment(date) {
            return moment(date);
        },
        isLessThanMonth(date) {
            let today = moment()
            let monthBefore = today.subtract(1, 'months')
            let compareDate = moment(date)
            return monthBefore <= compareDate
        },
        openUpdateModalIdSheet() {
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: IdSheetUpdate,
                props: {
                    companyId: this.basicData.companyId,
                    general_book_id_sheet: this.basicData.general_book_id_sheet
                },
                events: {
                    updateIdSheet: (newId) => {
                        this.basicData.general_book_id_sheet = newId
                    },
                },
            });
        },
        openUploadFileUsers(fileId) {
            let allUsersByFileId = this.allFilesByUser.filter(fileUser => {
                let fileFinded = fileUser.files.filter(file => file.id == fileId)
                return fileFinded.length > 0
            })
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: UploadFileAsUserModal,
                canCancel: ['escape', 'button', 'outside'],
                // onCancel: () => this.onModalClose(),
                props: {
                    fileId,
                    idCompany: this.basicData.companyId,
                    hideHistoricBtn: false,
                    selectedFilesByUser: allUsersByFileId,
                    sendMail: false,
                },
                events: {
                    // close: () => {
                    //     this.onModalClose();
                    // }
                },
            });
        },
        openEnviarCorreoTaxDocuments(which) {
            let allUsersByFileId = this.allUsers;
            if (allUsersByFileId == null || allUsersByFileId.length == 0) {
                alert('Error, no se encontraron usuarios para enviar un correo');
                return;
            }
            const message = which == 'sii' ? 'Enviar el correo con las obligaciones a' :
                'Enviar el correo con los movimientos bancarios a';
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: UploadFileAsUserModal,
                canCancel: ['escape', 'button', 'outside'],
                // onCancel: () => this.onModalClose(),
                props: {
                    idCompany: this.basicData.companyId,
                    hideHistoricBtn: false,
                    usersForEmail: this.allUsers,
                    selectedFilesByUser: allUsersByFileId,
                    noText: true,
                    which: which,
                    noTextMessage: message,
                    sendMail: true,
                },
                events: {
                    // close: () => {
                    //     this.onModalClose();
                    // }
                },
            });
        },
        openModalReloadReport(which) {
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: ReloadFintocByCompany,
                props: {
                    rutCompany: this.companyRut,
                    product: which,
                },
                events: {
                    close: () => {
                    }
                },
            });
        },
        openUpdateOperationsByUserModal() {
            let allUsersByFileId = this.allUsers;
            if (allUsersByFileId == null || allUsersByFileId.length == 0) {
                alert('Error, no se encontraron usuarios para enviar un correo');
                return;
            }
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: ChangeOperationsByUsers,
                canCancel: ['escape', 'button', 'outside'],
                props: {
                    idCompany: this.basicData.companyId,
                },
            });
        },
        sendObligationsToDrive(which) {
            let downloadToSheetFunc = null
            if (which == 'sii') {
                downloadToSheetFunc = downloadObligationsToSheet
            } else if (which == 'bank') {
                downloadToSheetFunc = downloadMovementsToSheet
            } else if (which == 'classification') {
                downloadToSheetFunc = exportClassificationsToSheet
            }

            this.loadingReloadDrive = true
            downloadToSheetFunc({
                rut_company: this.companyRut,
            }).then(({ data }) => {
                notificate(
                    `<strong>Éxito!</strong><br>
                    `+ data,
                    "is-success is-light"
                );
            }).catch((error) => {
                consoleHandlerError({ error, empty: true });
            }).finally(() => {
                this.loadingReloadDrive = false
            })
        },
        openSolicitarArchivo(fileId) {
            let allUsersByFileId = this.allFilesByUser.filter(fileUser => {
                let fileFinded = fileUser.files.filter(file => file.id == fileId)
                return fileFinded.length > 0
            })
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: UploadFileAsUserModal,
                canCancel: ['escape', 'button', 'outside'],
                // onCancel: () => this.onModalClose(),
                props: {
                    fileId,
                    idCompany: this.basicData.companyId,
                    hideHistoricBtn: false,
                    selectedFilesByUser: allUsersByFileId,
                    sendMail: true,
                },
                events: {
                    // close: () => {
                    //     this.onModalClose();
                    // }
                },
            });
        },
        goToSheet() {
            let parcialUrl = 'https://docs.google.com/spreadsheets/d/' + this.basicData.general_book_id_sheet + '/view'
            window.open(parcialUrl, "_blank");
        },
        openUpdateUsernamePassModal() {
            let allUsersByFileId = this.allUsers;
            if (allUsersByFileId == null || allUsersByFileId.length == 0) {
                alert('Error, no se encontraron usuarios para enviar un correo');
                return;
            }
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: ChangeUsernamePass,
                canCancel: ['escape', 'button', 'outside'],
                props: {
                    idCompany: this.basicData.companyId,
                    allUsers: this.allUsers,
                },
                events: {
                    close: () => {
                        getUsersByCompany(this.basicData.companyId).then(({ data }) => {
                            this.allUsers = data
                        })
                    }
                },
            });
        },
    },
    mounted() {
        if (this.basicData.oldest_join_date) {
            this.isLoading = false;
        }
    },
    watch: {
        'basicData.oldest_join_date': function (newVal) {
            if (newVal) {
                this.isLoading = false;
            }
        },
    },
};
</script>
<style scoped>
.logo_column {
    width: 200px;
    text-align: center;
}

.archivo_button {
    border-radius: 1px;
    border: 0;
    padding: 2px 5px;
    background-image: linear-gradient(225deg, #f5f5f5, #fafafa);
    white-space: nowrap;
    filter: drop-shadow(-1px 1px 2px #d0d0d099);
}

.archivo_button:hover {
    transform: translateY(-2px);
    filter: drop-shadow(-1px 1px 3px #d0d0d0ff);
}

.archivo_button:active {
    transform: translateY(1px);
}

.is-secondary {
    margin-left: 10px;
}

.simple_button_extra {
    border: 1px solid #c0c0ff;
}

.sii_b_msg {
    width: 80%;
}

.sii_logo_td {
    width: 20%;
}

.sii_logo {
    height: 2em;
    width: 4em;
    padding-top: 6px;
    padding-left: 10px;
}

.volverButton {
    position: absolute;
    top: 20px;
    right: 10px;
}

.arrow {
    text-align: bottom;
    height: 22px;
    padding-top: 4px;
}

.add_user_button {
    font-size: 0.9em;
    margin: 9px 0 0 0;
    padding: 3px 20px 3px 20px;
    background: linear-gradient(350deg, #f8d2ef, #fbf7ff) !important;
}

.user_button {
    background: linear-gradient(225deg, #eff9ff, #fafdff);
}

.company_logo {
    height: 30px;
    min-height: 30px;
    max-height: 30px;
}

.btn_danger {
    background-color: tomato;
    margin: 9px 0 0 2px;
    padding: 3px 20px 3px 20px;
    border-radius: 1px;
    border: 0;
    white-space: nowrap;
    filter: drop-shadow(-1px 1px 2px #d0d0d099);
}
</style>